import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'

import { FooterItem, Root } from './index.styles'

interface LegalFooterProps {
  withAdditionalPadding?: boolean
}

const LegalFooter = ({ withAdditionalPadding = false }: LegalFooterProps) => {
  const { t } = useTranslation()

  const currentYear = DateTime.now().year

  return (
    <Root $withAdditionalPadding={withAdditionalPadding}>
      <FooterItem href="https://informaconnect.com/terms-of-use/" target="_blank">
        {t(translations.TERMS)}
      </FooterItem>
      <FooterItem href="https://www.informa.com/privacy-policy/" target="_blank">
        {t(translations.PRIVACY)}
      </FooterItem>
      <FooterItem>©{currentYear} EBD GmbH</FooterItem>
    </Root>
  )
}

export default LegalFooter
